/***
 * @Authors:
 *      Ashwin Rai (ashwinrai.com)
 *      Nikhil Chougule
 ***/

/*** Imports ***/

/* Library imports */
import React , {Component} from 'react';
import PropTypes from 'prop-types';
import LoginHeader from "../LoginHeader/LoginHeader";
/* Component imports */

/* Style imports */
import './styles.css'
import BtnOutlineLg from "../ButtonsLg/BtnOutlineLg/BtnOutlineLg";
import BtnSolidLg from "../ButtonsLg/BtnSolidLg/BtnSolidLg";
import LoginHeader2 from "../LoginHeader/LoginHeader2";
/*** End Imports ***/

const TopWrapper = props => {

    return(
        <div className="top-login-container-main">
            {/* <LoginHeader
                title = {props.title}
                showHeaderLftBtn = {props.showHeaderLftBtn}
                showHeaderRgtBtn = {props.showHeaderRgtBtn}
                leftBtnClickListener = {props.leftBtnClickListener}
                rightBtnClickListener = {props.rightBtnClickListener}
                leftBtnMaterialIcon = {props.leftBtnMaterialIcon}
                rightBtnMaterialIcon = {props.rightBtnMaterialIcon}
            /> */}
            <LoginHeader2
                onClickCrossIcon = {props.onClickCrossIcon}
                title = {props.title}
                iconUrl = {props.iconUrl}
            />
            {props.children}
        </div>
    );
};
TopWrapper.propTypes = {
    showHeaderLftBtn: PropTypes.bool,
    showHeaderRgtBtn: PropTypes.bool,
    leftBtnClickListener: PropTypes.func,
    rightBtnClickListener: PropTypes.func,
    leftBtnMaterialIcon: PropTypes.string,
    rightBtnMaterialIcon: PropTypes.string,
    title: PropTypes.string.isRequired,
    showFooter: PropTypes.bool,
    previousBtnLabel: PropTypes.string,
    onPreviousClick: PropTypes.func,
    nextBtnLabel: PropTypes.string,
    onNextClick: PropTypes.func,
    isNextDisabled: PropTypes.bool
};

TopWrapper.defaultProps ={
    showFooter: false,
    previousBtnLabel: "Back",
    nextBtnLabel: "Next",
    isNextDisabled: false,
    showHeaderLftBtn: false,
    showHeaderRgtBtn: false
};

export default TopWrapper;




// WEBPACK FOOTER //
// ./src/components/core/LoginWrapper/TopWrapper.js


// WEBPACK FOOTER //
// ./src/components/core/LoginWrapper/TopWrapper.js